import { connect } from 'react-redux';

import { getPublishedEvent, requestAuthOtp, resetMeta, resetPage } from '../../actions/LoginPage';
import LoginPage from './LoginPage';

const mapsStateToProps = state => ({
	loginPageProps: state.loginPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getPublishedEvent() {
		dispatch(getPublishedEvent());
	},
	requestAuthOtp(options) {
		dispatch(requestAuthOtp(options));
	},
	resetPage() {
		dispatch(resetPage());
	},
	resetMeta() {
		dispatch(resetMeta());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(LoginPage);
